module.exports = __webpack_public_path__ + "static/media/hqt_bg.90c45537.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hqt_bg.png
// module id = 739
// module chunks = 0 1